/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import "../../styles/info.css";
import MertPhoto from "../../assets/images/MertFoto.jpg";

const BioInfoPanel = () => {
  return (
    <div className="info-panel">
      <div className="file-info">
        <div className="cell file-name mobile-border">
          <i className="fa-solid fa-file"> </i>
          bioInfo.mrt
        </div>
      </div>
      <div className="info-content">
        <p className="info-entrance">
          // Programing languages and tools I have learned or am learning
        </p>
      </div>
      <div className="person-card">
        <img src={MertPhoto} alt="" />
        <div className="person-info">
          <p className="purple-text">@mertarinci</p>
          <p className="info-text">Created a week ago</p>
        </div>
      </div>
      <div className="skills-container">
        <div className="skill-row">
          <div className="skill">
            <i class="fa-brands fa-html5"></i>
            <p className="skill-text">HTML</p>
          </div>
          <div className="skill">
            <i class="fa-brands fa-css3-alt"></i>
            <p className="skill-text">CSS</p>
          </div>
          <div className="skill">
            <i className="fa-brands fa-js"></i>
            <p className="skill-text">JavaScript</p>
          </div>
        </div>

        <div className="skill-row">
          <div className="skill">
            <i class="fa-solid fa-server"></i>
            <p className="skill-text">MongoDB</p>
          </div>
          <div className="skill">
            <i class="fa-solid fa-database"></i>
            <p className="skill-text">SQL</p>
          </div>
          <div className="skill">
            <i class="fa-brands fa-react"></i>
            <p className="skill-text">React</p>
          </div>
        </div>

        <div className="skill-row">
          <div className="skill">
            <i class="fa-brands fa-python"></i>
            <p className="skill-text">Python</p>
          </div>
          <div className="skill">
            <i class="fa-brands fa-git"></i>
            <p className="skill-text">Git</p>
          </div>
          <div className="skill">
            <i class="fa-brands fa-wordpress"></i>
            <p className="skill-text">WordPress</p>
          </div>
        </div>

        <div className="skill-row">
          <div className="skill">
            <i class="fa-brands fa-angular"></i>
            <p className="skill-text">Angular</p>
          </div>
          <div className="skill">
            <i class="fa-solid fa-code"></i>
            <p className="skill-text">TypeScript</p>
          </div>
          <div className="skill">
            <i class="fa-solid fa-hashtag"></i>
            <p className="skill-text">C#</p>
          </div>
        </div>
      </div>

      <div className="info-content">
        <p className="info-entrance mt-25">
          // Operating systems, other tools and skills
        </p>
      </div>
      <div className="person-card">
        <img src={MertPhoto} alt="" />
        <div className="person-info">
          <p className="purple-text">@mertarinci</p>
          <p className="info-text">Created two weeks ago</p>
        </div>
      </div>
      <div className="skills-container mb-15">
        <div className="skill-row">
          <div className="skill">
            <i class="fa-brands fa-apple"></i>
            <p className="skill-text">MacOS</p>
          </div>
          <div className="skill">
            <i class="fa-brands fa-windows"></i>
            <p className="skill-text">Windows</p>
          </div>
          <div className="skill">
            <i class="fa-brands fa-ubuntu"></i>
            <p className="skill-text">Ubuntu/Linux</p>
          </div>
        </div>
        <div className="skill-row">
          <div className="skill">
            <i class="fa-solid fa-cloud"></i>
            <p className="skill-text">API Dev.</p>
          </div>
          <div className="skill">
            <i class="fa-brands fa-docker"></i>
            <p className="skill-text">Docker</p>
          </div>
          <div className="skill">
            <i class="fa-solid fa-server"></i>
            <p className="skill-text">ExpressJS</p>
          </div>
        </div>
        <div className="skill-row">
          <div className="skill">
            <i class="fa-brands fa-php"></i>
            <p className="skill-text">Plugin Dev.</p>
          </div>
          <div className="skill">
            <i class="fa-solid fa-magnifying-glass-dollar"></i>
            <p className="skill-text">SEO/SEA</p>
          </div>
          <div className="skill">
            <i class="fa-solid fa-arrows-split-up-and-left"></i>
            <p className="skill-text">Agile</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BioInfoPanel;
